'use client'
import { useRef } from 'react'
import type { FC } from 'react'
import styled from 'styled-components'
import { motion, useInView } from 'motion/react'
import type { TypeValueSlide } from '@/app/[lang]/(public)/(staticPages)/about-us/values/page'
import { useScrollTracker } from '@/hooks'
import { ListInfoRows } from '../ListInfoRows'

type Props = {
  data: TypeValueSlide[]
}


export const MainValuesV2: FC<Props> = ({ data }) => {
  const ref = useRef<HTMLElement | null>(null)
  const { scrollState } = useScrollTracker()
  const isInView = useInView(ref, {
    once: false,
    initial: false,
  })

  return (
    <Main $scrollingUp={scrollState === 'SCROLLING_UP'}>
      <motion.section ref={ref} initial={{ opacity: 0 }} animate={{ opacity: isInView ? 1 : 0 }} transition={{ duration: .3 }}>
        <ListInfoRows data={data} />
      </motion.section>
    </Main>
  )
}

const Main = styled.main<{ $scrollingUp: boolean }>`
  background-color: var(--color-background--dark);
  display: flex;
  grid-column: 1;
  scroll-snap-type: y mandatory;
  position: relative;
`

